import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { Img } from '../../ui-kit/Img/Img.js';
import { getAspectsAttributes } from '../../utils/dataAttributes.js';
import { style } from '../../utils/style.js';
const BUTTON_SIZE_STYLE = {
    default: 'w-6 h-6',
    large: 'w-12 h-12',
};
export const HeaderSecondaryMenuButton = JSX(({ className, isRounded, buttonSize = 'default', isGrayBg = false, disabled, ariaLabel = 'Меню второго уровня', image, data, onClick, version, }) => {
    const grayBg = isGrayBg && !isRounded ? 'bg-main-divider' : '';
    const bgColor = version === 'transparent' ? 'backdrop-opacity-30 bg-white/30' : grayBg;
    return (_jsx("button", { className: style('group/btn border-0 flex shrink-0 items-center', isGrayBg ? 'p-s rounded-full' : 'p-0 bg-inherit', bgColor, isRounded
            ? 'w-8 h-8 text-secondary-light hover:text-secondary-hove'
            : `${BUTTON_SIZE_STYLE[buttonSize]} text-primary-text hover:text-primary-main`, 'group-data-transparent:text-white', className), type: "button", disabled: disabled, "aria-label": ariaLabel, onClick: onClick, ...getAspectsAttributes(data), children: _jsx(Img, { image: image, className: style('h-full', {
                'bg-main-divider/20 rounded-full': isRounded,
            }), imageClassName: "group-hover/btn:text-primary-hover group-hover/btn:invert-0" }) }));
});
//# sourceMappingURL=HeaderSecondaryMenuButton.js.map